export default __webpack_public_path__ + "static/media/HRSC-Logo-2022-1280.a20dd10e.png";